import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBusinessDetailsFromCIN } from "../../apis/getBusinessDetailsFromCIN";
import { getIECDetails } from "../../apis/getIECDetails";

export const getIECDetailsAction = createAsyncThunk(
  "getIECDetailsAction",
  async (value: any) => {
    return getIECDetails(value).then((response: any) => {
      return response.data;
    });
  }
);
